import type { ErrorPanelState } from '@typings';

/*
 * Plain selectors for the error panel store state. Subscribe with the
 * store hook: useErrorPanelStore(selectErrorsByScope).
 */
export const selectErrorsByScope = (
    state: ErrorPanelState,
): ErrorPanelState['errorsByScope'] => state.errorsByScope;
